module.exports = __webpack_public_path__ + "public/images/header/greetings.f1cd555626e5facb008365db34a48e99.svg";